import { Injectable, inject } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RecommendationsDialogInfo } from './models/user-config.response';
import { UserConfigState } from './user-config.state';
import { GetUserConfig, SetPendingNotifications } from './user-config.actions';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserConfigFacade {
  private readonly store = inject(Store);
  private readonly authService = inject(AuthService);

  @Select(UserConfigState.getRecommendationsDialogInfo)
  recommendationsDialogInfo$!: Observable<RecommendationsDialogInfo>;
  @Select(UserConfigState.getPendingNotifications) pendingNotifications$!: Observable<boolean>;

  get recommendationsDialogInfo() {
    return this.store.selectSnapshot(UserConfigState.getRecommendationsDialogInfo);
  }

  get pendingNotifications() {
    return this.store.selectSnapshot(UserConfigState.getPendingNotifications);
  }

  getUserConfig(): Observable<GetUserConfig> {
    if (!this.authService.isAuthenticated()) {
      return;
    }
    return this.store.dispatch(new GetUserConfig());
  }

  setPendingNotifications(pendingNotifications: boolean): Observable<SetPendingNotifications> {
    return this.store.dispatch(new SetPendingNotifications(pendingNotifications));
  }
}
